import { observer } from "mobx-react";
import { useStores } from "../../stores/useStores";
import { useEffect, useRef, useState } from "react";
import Vibrant from "node-vibrant";
import classNames from "classnames";
import {
  getAltText,
  IReactiveMediaContentItem,
} from "../../components/schoolfeed/SchoolFeedContentItem";
import { SocialItemModalNavigationProps } from "../../components/modals/SocialItemModal";
import ImageComponent from "../../components/utilities/ImageComponent";
import { EditButton } from "../../components/blocks/TerracedGridTheme/EditButton";
import { handleContentItemClick } from "../../components/blocks/SchoolBlocks/ContentItemBlock/ContentItemBlock";
import styles from "./styles/Gallerypage.module.scss";
import { CSSTransition } from "react-transition-group";

const visibilityTransitionClassNames = {
  enter: styles.transitionEnter,
  appear: styles.transitionAppear,
  enterActive: styles.transitionEnterActive,
  appearActive: styles.transitionAppearActive,
  enterDone: styles.transitionEnterDone,
  appearDone: styles.transitionAppearDone,
  exit: styles.transitionExit,
  exitActive: styles.transitionExitActive,
  exitDone: styles.transitionExitDone,
};
export const GalleryItem = observer(
  (
    props: {
      item: IReactiveMediaContentItem;
      handleDeleteContentItem: (c: ContentItem) => void;
    } & SocialItemModalNavigationProps,
  ) => {
    const { userStore } = useStores();
    const ref = useRef(null);
    const imgSource = props.item.image || "";
    const [bgColor, setBgColor] = useState<string | null>(null);

    useEffect(() => {
      if (imgSource) {
        Vibrant.from(imgSource)
          .quality(1)
          .getPalette((err, palette) => {
            let color =
              palette?.LightMuted ||
              palette?.DarkMuted ||
              palette?.LightVibrant ||
              palette?.DarkVibrant ||
              palette?.Vibrant ||
              palette?.Muted;

            if (color) {
              setBgColor(`rgb(${color.r}, ${color.g}, ${color.b})`);
            } else {
              setBgColor("lightgrey");
            }
          });
      } else {
        setBgColor("lightgrey");
      }
    }, []);

    const mediaItemClassName = classNames({
      [styles.mediaItem]: true,
      [styles.mediaItemHidden]: !props.item.published,
    });

    return (
      <CSSTransition
        classNames={visibilityTransitionClassNames}
        timeout={100}
        in={!!bgColor}
        appear={true}
        nodeRef={ref}
        className={styles.galleryItem}
      >
        <div
          ref={ref}
          style={{ backgroundColor: bgColor || "", cursor: "pointer" }}
          onClick={() => {
            handleContentItemClick(
              props.item,
              {
                totalItemCount: props.totalItemCount,
                initialItemIndex: props.initialItemIndex,
                getItemAtIndex: props.getItemAtIndex,
              },
              props.handleDeleteContentItem,
            );
          }}
        >
          <div className={mediaItemClassName}>
            <ImageComponent
              key={props.item.id}
              src={imgSource}
              alt={getAltText(props.item)}
            />
            {userStore.isEditor && (
              <EditButton
                contentItem={props.item}
                handleDelete={props.handleDeleteContentItem}
                className={styles.editButton}
              />
            )}
          </div>
        </div>
      </CSSTransition>
    );
  },
);
